const css = `.gduc7W__barWrapper{width:100%;height:8px;border-radius:4px;position:relative;overflow:hidden}.gduc7W__barWrapper .gduc7W__progress{height:100%;background-color:#0070eb;border-radius:0 4px 4px 0;transition:transform .75s cubic-bezier(.3,1,.32,1);position:absolute}.gduc7W__barBackground{background-color:#e7e9e9}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"progress":"gduc7W__progress","barWrapper":"gduc7W__barWrapper","barBackground":"gduc7W__barBackground"};
